<!-- enColumn -->
<template>
  <div class="enColumn">
    <el-form :model="ruleForm" label-width="160px">
      <el-form-item label="英文栏目名称：" prop="enColumn" style="width: 50%;">
        <el-input v-model="ruleForm.enColumn" type="text" />
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  name: 'enColumn',
  data() {
    return {}
  },
  props: {
    ruleForm: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  components: {},
  computed: {},
  mounted() {},
  methods: {}
}
</script>

<style lang="scss" scoped></style>
